module.exports = __webpack_public_path__ + "static/media/new-medical-record.ec5ce986.svg";